import HttpService from '@/api/HttpService';
import { downloadCSVBlob } from '../../util';

export default {
  namespaced: true,
  actions: {
    getFeedbackStatus({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.getV2('feedback/status')
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    submitFeedback({ commit }, payload) { // eslint-disable-line no-unused-vars
      return HttpService.postV2('feedback', payload)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    getUserFeedback({ commit }, userId) { // eslint-disable-line no-unused-vars
      return HttpService.getV2(`users/${userId}/feedback`)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    exportFeedbackReport({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.getV2('reports/feedback').then(blob =>
        downloadCSVBlob('feedback_results.csv', blob),
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/feedback.js